import { collection, addDoc, Timestamp, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../../../../firebase/config';

export type ManagerFormData = {
    name: string;
    mobile: string;
    email: string;
    type: string;
};

export async function submitManager(bankId: string, formData: ManagerFormData): Promise<void> {
    if (!bankId) {
        throw new Error('Bank ID is required');
    }

    // Check for duplicate email
    const managersCollectionRef = collection(db, 'banks', bankId, 'managers');
    const q = query(managersCollectionRef, where('email', '==', formData.email.trim()));
    const querySnapshot = await getDocs(q);

    if (!querySnapshot.empty) {
        throw new Error('A manager with this email already exists.');
    }

    const managerData: any = {
        name: formData.name.trim(),
        mobile: formData.mobile.trim() || '',
        email: formData.email.trim(),
        type: formData.type.trim(),
        createdAt: Timestamp.now(),
    };

    await addDoc(collection(db, 'banks', bankId, 'managers'), managerData);
}

export async function submitBulkManagers(bankId: string, managers: ManagerFormData[]): Promise<{ created: number; skipped: number; skippedRows: any[] }> {
    if (!bankId) {
        throw new Error('Bank ID is required');
    }

    let createdCount = 0;
    let skippedCount = 0;
    const skippedRows: any[] = [];

    const managersCollectionRef = collection(db, 'banks', bankId, 'managers');

    for (const manager of managers) {
        let skipReason = '';

        // Validate required fields
        if (!manager.name?.trim() || !manager.email?.trim() || !manager.type?.trim()) {
            skipReason = 'Missing required fields';
        } else {
            // Check for duplicate email
            const q = query(managersCollectionRef, where('email', '==', manager.email.trim()));
            const querySnapshot = await getDocs(q);

            if (!querySnapshot.empty) {
                skipReason = 'Duplicate email';
            }
        }

        if (skipReason) {
            skippedCount++;
            skippedRows.push({
                Name: manager.name,
                Mobile: manager.mobile,
                Email: manager.email,
                Type: manager.type,
                Reason: skipReason,
            });
            continue;
        }

        try {
            const managerData: any = {
                name: manager.name.trim(),
                mobile: manager.mobile?.trim() || '',
                email: manager.email.trim(),
                type: manager.type.trim(),
                createdAt: Timestamp.now(),
            };

            await addDoc(managersCollectionRef, managerData);
            createdCount++;
        } catch (err: any) {
            console.error('Error creating manager from Excel:', err);
            skippedCount++;
            skippedRows.push({
                Name: manager.name,
                Mobile: manager.mobile,
                Email: manager.email,
                Type: manager.type,
                Reason: 'Error saving to Firestore',
            });
        }
    }

    return { created: createdCount, skipped: skippedCount, skippedRows };
}

